export const MeteringDataSectionId = 'metering-data-section'
export const DeviceMeteringsDataRowHeight = 60
